import type { TemplateFormValues } from "./TemplateForm";

export const templateFormSamples: Partial<TemplateFormValues>[] = [
  {
    name: "ຮ່າງເອກະສານ PO (ສັ່ງຊື້)",
    categoryId: undefined,
    description: "ຮ່າງເອກະສານສັ່ງຊື້ສິນຄ້າຈາກຜູ້ສະໜອງ",
    usageNotes: "ໃຊ້ສໍາລັບການສັ່ງຊື້ສິນຄ້າທົ່ວໄປ. ກະລຸນາຕື່ມຂໍ້ມູນລາຍລະອຽດຕາມຄວາມຈໍາເປັນ",
    departmentIds: [],
    version: "1.0",
    changelog: "ສ້າງຮ່າງເອກະສານເບື້ອງຕົ້ນ",
    keepOldVersionsActive: true,
  },
  {
    name: "ຮ່າງເອກະສານ PR (ການຊື້)",
    categoryId: undefined,
    description: "ຮ່າງເອກະສານການຮ້ອງຂໍຊື້ສິນຄ້າຫຼືບໍລິການ",
    usageNotes: "ໃຊ້ສໍາລັບການຮ້ອງຂໍຊື້ສິນຄ້າກ່ອນການສັ່ງຊື້. ຕ້ອງມີການອະນຸມັດຈາກຜູ້ບໍລິຫານກ່ອນ",
    departmentIds: [],
    version: "1.0",
    changelog: "ສ້າງຮ່າງເອກະສານເບື້ອງຕົ້ນ",
    keepOldVersionsActive: true,
  },
  {
    name: "ຮ່າງເອກະສານອິນວອີສ໌ (ໃບເກັບເງິນ)",
    categoryId: undefined,
    description: "ຮ່າງເອກະສານໃບເກັບເງິນສໍາລັບລູກຄ້າ",
    usageNotes: "ໃຊ້ສໍາລັບການອອກໃບເກັບເງິນຫຼັງການຂາຍສິນຄ້າ. ຕ້ອງມີເລກທີ່ເປັນລະບຽບ",
    departmentIds: [],
    version: "1.0",
    changelog: "ສ້າງຮ່າງເອກະສານເບື້ອງຕົ້ນ",
    keepOldVersionsActive: true,
  },
  {
    name: "ຮ່າງເອກະສານບີນ (Receipt)",
    categoryId: undefined,
    description: "ຮ່າງເອກະສານໃບຮັບເງິນຈາກລູກຄ້າ",
    usageNotes: "ໃຊ້ສໍາລັບການອອກໃບຮັບເງິນເມື່ອລູກຄ້າຊໍາລະເງິນ. ຕ້ອງບັນທຶກເປັນລາຍການ",
    departmentIds: [],
    version: "1.0",
    changelog: "ສ້າງຮ່າງເອກະສານເບື້ອງຕົ້ນ",
    keepOldVersionsActive: true,
  },
  {
    name: "ຮ່າງເອກະສານກອນເທຣັກ (Contract)",
    categoryId: undefined,
    description: "ຮ່າງເອກະສານສັນຍາກັບລູກຄ້າຫຼືຜູ້ສະໜອງ",
    usageNotes: "ໃຊ້ສໍາລັບການສ້າງສັນຍາທາງການຄ້າ. ຄວນກວດສອບດ້ວຍທີ່ປຶກສາກົດໝາຍກ່ອນ",
    departmentIds: [],
    version: "1.0",
    changelog: "ສ້າງຮ່າງເອກະສານເບື້ອງຕົ້ນ",
    keepOldVersionsActive: true,
  },
];
